import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import StatusComp from "../../../components/StatusComp";
import CommonDatePicker from "../../../components/CommonDatePicker";
import SelectBox from "../../../components/SelectBox";
import {
  companyDetails,
  groupUsers,
  siteDetails,
} from "../../redux/api/dummyJson";
import { knf_logo } from "../../../assets/imgs";
import UserReportTable from "../../../components/chart/UserReportTable";
import UserReportTable1 from "../../../components/chart/UserReportTable1";
import { post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import moment from "moment/moment";
import UserReportPage from "./UserReportPage";

// import { companyDetails, groupUsers, siteDetails } from '../../constants/redux/api/dummyJson'

const UserReport = () => {
  const navigate = useNavigate();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const [company, setCompany] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState([]);

  const [siteData, setSiteData] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [reportData, setReportData] = useState({});
  const [selectedUser, setSelectedUser] = useState(null);

  const location = useLocation();
  const type = location?.state?.type;

  const data = location.state?.data;

  const createdAt = moment().format("DD-MM-YYYY");
  const [comapanyList, setCompanyList] = useState([]);
  const [siteList, setSiteList] = useState([]);

  const getCompanyList = () => {
    post(URL.COMPANY_LIST_ADMIN, {})
      .then((res) => {
        setCompanyList(res?.companies);
        setSiteList([]);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getSiteList = (company_id) => {
    let formdata = new FormData();
    setSelectedCompany(company_id);
    formdata.append("company_id", company_id?.value);
    post(URL.ACTIVE_ADMIN_SITE, formdata)
      .then((res) => {
        if (res?.sites?.length > 0) {
          setSiteList(res?.sites);
        } else {
          setSiteList([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getCompanyList();
  }, []);

  console.log("selectedCompany", selectedCompany);

  const handlePreview = () => {
    let formdata = new FormData();
    formdata.append("from_date", moment(fromDate).format("YYYY-MM-DD"));
    formdata.append("to_date", moment(toDate).format("YYYY-MM-DD"));
    formdata.append("site_id", selectedOption?.value);
    post(URL.GET_USER_REPORT_ADMIN, formdata)
      .then((res) => {
        if (res?.data) {
          setReportData(res?.data);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  return (
    <div className="dashRightView">
      <StatusComp name={"User"} type={"Report"} hide={true} />
      <div className={`d-flex col-md-12 ${type ? "gap-5" : "ac-jb"}`}>
        {/* Company Select */}
        {!type && (
          <div className="col-md-2">
            <label className="form-label">Select Company</label>
            <SelectBox
              arrayData={comapanyList}
              data={company}
              setData={setCompany}
              selectedOption={selectedCompany}
              setSelectedOption={getSiteList}
              style={true}
            />
          </div>
        )}

        {/* Site Select */}
        {!type && (
          <div className="col-md-2">
            <label className="form-label">Select Site</label>
            <SelectBox
              arrayData={siteList}
              data={siteData}
              setData={setSiteData}
              selectedOption={selectedOption}
              setSelectedOption={setSelectedOption}
              disabled={selectedCompany?.label ? false : true}
              style={true}
            />
          </div>
        )}
        <CommonDatePicker
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />
        {/* Preview Button */}
        <div className="col-md-1 mt-4">
          <button
            onClick={handlePreview}
            className="submit-btn"
            disabled={
              !fromDate ||
              !toDate ||
              !selectedCompany?.label ||
              !selectedOption?.label
            }
          >
            Preview
          </button>
        </div>
      </div>

      {/* <div className="mt-3">
        <label className="form-label">Select Group User</label>
        <SelectBox
          arrayData={groupUsers}
          selectedOption={selectedUser}
          setSelectedOption={setSelectedUser}
          style={true}
        />
      </div> */}

      {/* second section */}

      {/* download btn */}
      {reportData?.company && <UserReportPage data={reportData} />}
    </div>
  );
};

export default UserReport;
